import * as React from 'react'

import { QUILL_CONNECT_ARROW, QUILL_CONNECT_IMAGE } from '../asset_constants'

const RecommendedPacksSlide = ({ slideGroupClassName, video=null }) => (
  <section className={`slide ${slideGroupClassName} recommended-packs-slide`} key="recommended-packs-slide">
    <div>
      <h1>Assign recommended activity packs to target skills</h1>
      <div className="flex-wrapper">
        {video ? <div className="video-wrapper">{video}</div> : <div className="img-wrapper"><img alt="Screenshot of the student interface in a Quill Connect activity." src={QUILL_CONNECT_IMAGE} /></div>}
        <div className="text">
          <p>Quill activities are built with <b>interactive practice and real-time feedback</b>, not passive multiple-choice questions. </p>
          <p>Activities are <b>10-15 min</b> and great as warm-up or bell ringer. To improve writing, we recommend 2-3 activities per week over 8 weeks.</p>
          <p className="highlight-box">
            Quill Connect activities use the evidence-based practice of sentence combining.
            <img alt="" className="arrow" src={QUILL_CONNECT_ARROW} />
          </p>
        </div>
      </div>
    </div>
  </section>
)

export default RecommendedPacksSlide
